import React from 'react';
export default function QuestionHeader(props) {

  const { surveyScreenData, template } = props;

  let [scrollPosition, HandlescrollPosition] = React.useState(0)

  let lastKnownScrollPosition = 0
  document.addEventListener('scroll', () => {
    lastKnownScrollPosition = window.scrollY;
    HandlescrollPosition(lastKnownScrollPosition)
  });

  // console.log("surveyScreenData",surveyScreenData)
  let headerColor = surveyScreenData && surveyScreenData.headerColor ? surveyScreenData.headerColor : "#ffffff";

  // console.log("headerColor---->",headerColor)

  return (
    <>
      {scrollPosition < 50 && template === 'v4' || true ?
        <div
          style={{ background: headerColor ? headerColor : "#ffffff" }}
          className="sticky top-0 left-0 w-full z-10   h-16">
          <div className="flex justify-between">
            <div className="">
              {(surveyScreenData && surveyScreenData.logo2) ?
                <img alt="newlogo2" className='object-contain   h-16'
                  src={surveyScreenData.logo2}
                /> : null}
            </div>



            <div className="">
              {(surveyScreenData && surveyScreenData.logo) ?
                <img alt="newlogo" className='object-contain  h-16 '
                src={surveyScreenData.logo}
                // src={''}
                /> : null}
            </div>
          </div>
        </div>
        : null}
    </>
  );
}